<template lang="html">
  <d-card class="card-small mb-4">
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <d-row class="align-items-center">
        <d-col cols="12" lg="4">
          <h6 class="m-0">Tipos de variações</h6>
        </d-col>
        <d-col cols="12" lg="8" class="text-right" >
          <d-button type="button" @click.stop="openTypeModal()">Novo tipo</d-button>
        </d-col>
      </d-row>
    </d-card-header>

    <d-list-group flush>
      <d-list-group-item class="p-3">
        <d-row>
          <d-col md="12">
            <table class="table mb-0 table-striped">
              <thead class="bg-light">
                <tr>
                  <th scope="col" class="col-2 border-0">Nome</th>
                  <th scope="col" class="col-10 border-0">Opções</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(type, index) in model.types" :key="index">
                  <td class="link align-center">
                    <span class="label delete" @click="deleteType(type)"><i class="material-icons">delete</i></span>
                    <a @click="openTypeModal(type)">{{ type.name }}</a>
                  </td>
                  <td>
                    <ul class="options">
                      <li v-for="(option, index) in type.options" :key="index" class="label-pill">
                        <span class="label delete" @click="deleteOption(option)"><i class="material-icons">delete</i></span>
                        <span class="label" @click="openOption(type, option)">{{ option.name }}</span>
                      </li>
                      <li class="label-pill">
                        <span class="label" @click="openOption(type)">+ Novo</span>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </d-col>
        </d-row>
        <d-row v-if="model.types.length == 0">
          <d-col class="no-content p-4">Ainda não foram cadastrados nenhum tipo de variação.</d-col>
        </d-row>
      </d-list-group-item>
    </d-list-group>
    <add-type-modal/>
    <add-type-option-modal/>
  </d-card>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import ProductService from '_services/rest/modules/product';
import AddTypeModal from '_modules/product/components/modal/AddTypeModal.vue';
import AddTypeOptionModal from '_modules/product/components/modal/AddTypeOptionModal.vue';
import {
  MODEL_TYPE,
  MODEL_TYPE_OPTION,
  _LOAD_TYPE_MODEL_,
  _RELOAD_VARIATION_,
  _DELETE_PRODUCT_TYPE_,
  _DELETE_PRODUCT_OPTION_,
  _LOAD_TYPE_OPTION_MODEL_,
} from './ProductModel';

const modalType = 'add_variation_type_modal';
const modalTypeOption = 'add_variation_type_option_modal';

export default {
  name: 'variations',
  components: {
    AddTypeModal,
    AddTypeOptionModal,
  },
  data() {
    return {
      model: {
        types: [],
      },
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    deleteOption(option) {
      this.setToggle({ type: 'confirm_modal', bool: true });
      Events.$emit(_DELETE_PRODUCT_OPTION_, option);
    },
    deleteType(type) {
      this.setToggle({ type: 'confirm_modal', bool: true });
      Events.$emit(_DELETE_PRODUCT_TYPE_, type);
    },
    getTypes() {
      const { product } = this.$store.state.product;
      if (product.id) {
        ProductService.getTypesList(product.id)
          .then(response => {
            this.model.types = response;
          });
      }
    },
    openTypeModal(type = MODEL_TYPE) {
      Events.$emit(_LOAD_TYPE_MODEL_, type);
      this.setToggle({ type: modalType, bool: true });
    },
    openOption(type, option = MODEL_TYPE_OPTION) {
      Events.$emit(_LOAD_TYPE_OPTION_MODEL_, { type, option });
      this.setToggle({ type: modalTypeOption, bool: true });
    },

  },
  mounted() {
    Events.$on(_RELOAD_VARIATION_, () => {
      this.getTypes();
    });
    this.getTypes();
  },
};
</script>

<style lang="scss" scoped>
.col {
  &-2 {
    width: 25%;
  }
  &-8 {
    width: 75%;
  }
}

.align-center {
  vertical-align: middle;
}
.delete {
  cursor: pointer;
  margin-right: 7px;
}
.options {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: center;
  margin-bottom: 0;
  padding-left: 0;
  li {
    padding: 5px;
    margin-right: 5px;
    margin-bottom: 10px;
  }
}
</style>
